import React from 'react';
import { FormattedMessage } from 'react-intl';
import { Customers, EntityType } from '../../../entity/entity.types';
import { fetchLawyerCustomers } from '../../lawyer.api';
import { EnterprisesRepresentedByLawyer } from './EnterprisesRepresentedByLawyer';
import {
  CustomersTypologies,
  CompanySizeTypologies,
} from '../../../entity/charts/typologies';
import { UserContextType } from '../../../user/user.types';
import { withUser } from '../../../user/UserContext';
import { withLawyer } from '../LawyerContext';
import { LawyerContextType } from '../lawyer.types';

type Props = UserContextType & LawyerContextType;

type State = {
  customers: Customers;
  shouldDisplay: boolean;
};

export class RawLawyerClients extends React.Component<Props, State> {
  state: State = {
    customers: {
      typologies: {},
      enterprisesSizes: {},
      enterprisesSectors: {},
      sizes: {
        totalDecisions: 0,
        typologiesTotalSubset: 0,
        enterprisesSizesTotalSubset: 0,
        enterprisesSectorsTotalSubset: 0,
      },
    },
    shouldDisplay: false,
  };

  id = 'lawyer-clients';

  async componentDidMount() {
    const customers = await fetchLawyerCustomers(
      this.props.lawyerInfos.lawyerId,
    );
    this.setState({ customers }, () => {
      if (
        customers.sizes.typologiesTotalSubset > 0 ||
        customers.sizes.enterprisesSizesTotalSubset > 0 ||
        customers.sizes.enterprisesSectorsTotalSubset > 0
      ) {
        this.displaySection();
      }
    });
  }

  displaySection = () => {
    this.setState({ shouldDisplay: true }, () => {
      window.dispatchEvent(new CustomEvent('createNav', { detail: this.id }));
    });
  };

  render() {
    const {
      lawyerInfos: { firstname, lastname, lawyerId },
      loggedIn,
      lawyerName,
      experience: { decisionCount },
    } = this.props;
    const { customers, shouldDisplay } = this.state;
    const entityInfos: {
      entityId: string;
      entityName: string;
      entityType: EntityType;
      decisionCount: number;
    } = {
      entityId: lawyerId,
      entityName: lawyerName,
      entityType: 'lawyer',
      decisionCount,
    };
    return (
      <>
        {shouldDisplay && (
          <h2 id={this.id} className="entity__section-title">
            <FormattedMessage
              id="app.pages.lawyer.clients.title"
              values={{ lawyerName }}
            />
          </h2>
        )}
        {customers.sizes.typologiesTotalSubset > 0 && (
          <CustomersTypologies customers={customers} {...entityInfos} />
        )}
        {loggedIn && (
          <EnterprisesRepresentedByLawyer
            lawyerId={lawyerId}
            lawyerName={`${firstname} ${lastname}`}
            displaySection={this.displaySection}
            decisionCount={decisionCount}
          />
        )}
        {customers.sizes.enterprisesSizesTotalSubset > 0 && (
          <CompanySizeTypologies customers={customers} {...entityInfos} />
        )}
        {/* {customers.sizes.enterprisesSectorsTotalSubset > 0 && (
          <CompanySectorTypologies customers={customers} {...entityInfos} />
        )} */}
      </>
    );
  }
}

export const LawyerClients = withUser(withLawyer(RawLawyerClients));
